var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{class:['indicator', _vm.customClassName]},[_c('v-col',[_c('img',{attrs:{"src":require("@/assets/icons/collapse-dark-blue.svg"),"alt":"indicator icon"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }